<template>
    <VJoyDialog ref="profileViewBlocker" pattern-brand class="profile-view-blocker" data-testid="profile-view-blocker" @dialog:confirm="hide">
        <template #dialog-header>
            <p class="profile-view-blocker__header">
                {{ $t('profile.view.blocker.header') }}
            </p>
        </template>
        <template #dialog-subheader>
            <p class="profile-view-blocker__subheader">
                {{ $t('profile.view.blocker.subheader') }}
            </p>
        </template>
        <template #dialog-body>
            <MaltImg width="324" height="235" :src="getBrandIllustration('mediation-red.svg')" alt="" />
        </template>
        <template #dialog-confirm>
            <VJoyButton
                variant="main"
                size="medium"
                data-testid="profile-view-blocker-create-account"
                :label="$t('profile.view.blocker.create.account')"
                :href="signupUrl"
                rel="nofollow"
            />
        </template>
        <template #dialog-cancel>
            <VJoyButton
                variant="ghost"
                size="medium"
                data-testid="profile-view-blocker-signin"
                :label="$t('profile.view.blocker.signin')"
                :href="signinUrl"
            />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {computed, watch, useTemplateRef} from 'vue';
    import {useRoute} from '@typed-router';
    import {MaltImg} from '#components';
    import {useLocalePrefix} from '#imports';
    import {getBrandIllustration} from '@malt/asset-utils';
    import {VJoyDialog, VJoyButton} from '@maltjoy/core-vue';

    const profileViewBlocker = useTemplateRef('profileViewBlocker');

    const route = useRoute();
    const {withLocalePrefix} = useLocalePrefix();

    const props = defineProps<{
        open: boolean;
    }>();

    watch(
        () => props.open,
        () => {
            if (props.open) {
                profileViewBlocker.value?.show();
            }
        },
        {immediate: true},
    );

    function hide() {
        profileViewBlocker.value?.hide();
    }

    const currentPageUrl = route.fullPath;

    const signupUrl = computed(() => {
        return withLocalePrefix(
            `/who-are-you?redirect=${encodeURIComponent(currentPageUrl)}&pageSource=profile_page&componentSource=profile-view-blocker`,
        );
    });

    const signinUrl = computed(() => {
        return `/signin?redirect=${encodeURIComponent(currentPageUrl)}&pageSource=profile_page&componentSource=profile-view-blocker`;
    });
</script>

<style scoped lang="scss">
    .profile-view-blocker {
        &__header {
            max-width: 90%;
            margin: auto;
        }

        &__subheader {
            margin: auto;
            max-width: 90%;
            font-size: var(--joy-font-size-primary-400);
        }
    }
</style>
